import styled from "styled-components";

export const MediumText = styled.div.attrs({
  className: "text-lg font-bold",
})`
  color: var(--primaryPurpleMain);
`;
export const AnalyticsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const CategoryCardGrid = styled.div.attrs({
  // className: "lg:flex md:flex sm:block",
})`
  /* @media screen and (max-width: 768px) {
    width: fit-content;
    margin: auto;
  } */
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 20px;
`;

export const ReportCategoryCard = styled.div.attrs({
  className: "rounded mr-4 px-7 py-4 cursor-pointer",
})`
  background-color: rgba(181, 128, 255, 0.3);
  height: 200px;
  /* width: 300px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  align-items: left;
  color: var(--primaryPurpleMain);

  @media screen and (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const MapContainer = styled.div.attrs({
  className: "mb-7 mt-3",
})`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
`;

export const ChartContainer = styled.div.attrs({
  className: "",
})`
  display: flex;
`;

export const NoData = styled.div.attrs({})`
  font-size: xx-large;
  margin: 0 auto;
  color: gray;
`;
